import React from 'react';
import { AppRouter } from './AppRouter';
import { HelmetProvider } from 'react-helmet-async';
export function App() {
  return <HelmetProvider data-id="element-0">
      <AppRouter data-id="element-1" />
    </HelmetProvider>;
}